<template>
	<div class="bottom-0 w-full ">
		<div class="w-full flex justify-center items-center bg-white py-3">
			<div class="flex-1"></div>
			<div class="flex-1">
				<p class="text-sm">
					Powered By <span style="color: #00249C;"> Delievery Software </span>
				</p>
			</div>
			<div class="flex-1"></div>
		</div>
	</div>
</template>

<script>
	export default {
	    name: 'Footer',
	}
</script>